import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useBrandForm } from '../../hooks/useBrandForm'
import { PageBanner } from '../Banners/PageBanner'
import BrandFormFields from './components/BrandFormFields'
import Loader from '../Common/Loader'

interface BrandFormBaseProps {
  isEditMode: boolean
}

const BrandFormBase: React.FC<BrandFormBaseProps> = ({ isEditMode }) => {
  const {
    formData,
    loading,
    handleChange,
    handleSubmit,
    navigate
  } = useBrandForm(isEditMode)

  if (loading && isEditMode) {
    return <Loader />
  }

  return (
    <>
      <PageBanner
        title={isEditMode ? 'Edytuj markę' : 'Dodaj nową markę'}
        description={isEditMode ? 'Edytuj istniejącą markę' : 'Dodaj nową markę'}
      />

      <div className='container my-5'>
        <div className='row'>
          <div className='col-lg-8 mx-auto'>
            <div className='card'>
              <div className='card-header'>
                <h4>{isEditMode ? 'Edytuj markę' : 'Dodaj nową markę'}</h4>
              </div>
              <div className='card-body'>
                <form onSubmit={handleSubmit}>
                  <BrandFormFields
                    formData={formData}
                    onChange={handleChange}
                  />

                  <div className='form-group d-flex justify-content-between mt-4'>
                    <button
                      type='button'
                      className={`
                                      tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                      tw-text-white
                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-red-500 hover:tw-bg-opacity-90 focus:tw-bg-red-500
                                    `}
                      onClick={() => navigate('/brands')}
                    >
                      Anuluj
                    </button>

                    <button
                      type='submit'
                      className={`
                                      tw-mr-2 tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                      tw-text-white
                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                                    `}
                      disabled={loading}
                    >
                      {loading
                        ? (
                          <>
                            <span
                              className='tw-inline-block tw-h-4 tw-w-4 tw-animate-spin tw-rounded-full tw-border-2 tw-border-solid tw-border-current tw-border-r-transparent tw-mr-2'
                              role='status'
                              aria-hidden='true'
                            />
                            Zapisywanie...
                          </>
                          )
                        : (
                            isEditMode ? 'Zapisz zmiany' : 'Dodaj markę'
                          )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BrandFormBase
